var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:[
    _vm.isTippedContainer ? 'tipped-container' : null,
    'w-tko-component',
    _vm.modifier && ("w-tko-component--" + _vm.modifier) ],attrs:{"data-bind":"component: componentKo, eventDelegate: ['click']"}},'div',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }